/*
  Produse vazute recent.

  Se salveaza DOAR handle-ul produsului, nu pretul si nu titlul: datele se cer
  proaspat de la /products/<handle>.js la fiecare afisare, ca sa nu ramana in
  pagina un pret vechi sau un produs trecut intre timp la draft (acela da 404
  si iese singur din lista).

  Ruleaza pe toate paginile: pe cele de produs inregistreaza, oriunde exista
  containerul sectiunii randeaza. Daca localStorage e blocat, totul e no-op.
*/
(function () {
  var CHEIE = 'eu_vazute';
  var MAX = 12;

  function citeste() {
    try {
      var raw = localStorage.getItem(CHEIE);
      var v = raw ? JSON.parse(raw) : [];
      return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string'; }) : [];
    } catch (e) { return []; }
  }

  function scrie(lista) {
    try { localStorage.setItem(CHEIE, JSON.stringify(lista.slice(0, MAX))); } catch (e) {}
  }

  function handleCurent() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function inregistreaza() {
    var h = handleCurent();
    if (!h) return;
    var lista = citeste().filter(function (x) { return x !== h; });
    lista.unshift(h);
    scrie(lista);
  }

  function bani(cents, format) {
    var v = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return v + ' lei';
  }

  function card(p) {
    var img = p.featured_image
      ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2')
      : '';
    var redus = p.compare_at_price && p.compare_at_price > p.price;
    return (
      '<a class="eu-vr__item" href="' + p.url + '">' +
        '<span class="eu-vr__media">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</span>' +
        '<span class="eu-vr__name">' + p.title + '</span>' +
        '<span class="eu-vr__price' + (redus ? ' is-sale' : '') + '">' + bani(p.price) +
          (redus ? ' <s>' + bani(p.compare_at_price) + '</s>' : '') +
        '</span>' +
      '</a>'
    );
  }

  async function randeaza() {
    var root = document.querySelector('[data-eu-vazute]');
    if (!root) return;

    var track = root.querySelector('[data-eu-vazute-track]');
    var curent = handleCurent();
    var lista = citeste().filter(function (h) { return h !== curent; });
    var minim = Number(root.getAttribute('data-minim') || 2);

    if (lista.length < minim) return;

    var rezultate = [];
    var valide = [];
    for (var i = 0; i < lista.length; i++) {
      try {
        var r = await fetch('/products/' + encodeURIComponent(lista[i]) + '.js');
        if (!r.ok) continue;              // 404 = produs sters sau trecut la draft
        var p = await r.json();
        if (!p || p.available === false && root.getAttribute('data-ascunde-epuizate') === 'true') { valide.push(lista[i]); continue; }
        rezultate.push(card(p));
        valide.push(lista[i]);
      } catch (e) { /* il ignoram, dar nu-l stergem pentru o eroare de retea */ valide.push(lista[i]); }
    }

    // pastram in memorie doar ce mai exista
    if (valide.length !== lista.length) scrie(valide);

    if (rezultate.length < minim) return;
    track.innerHTML = rezultate.join('');
    root.hidden = false;
  }

  function porneste() {
    inregistreaza();
    randeaza();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
})();
